<div
  #list
  (ppOnRendered)="onTableRendered($event)"
  class="listCF__wrapper"
  (scroll)="scrollHandler($event)"
  >
  @for (matchedListItem of matchedListItems; track matchedListItem) {
    <div
      (click)="select(matchedListItem, matchedListItem.level); $event.stopPropagation()"
      >
      <span
        class="listCF__li-content listCF__search-results-item"
        [class.listCF__li-content--selected]="isSelected(matchedListItem.id)"
        [innerHTML]="matchedListItem.path | highlightFragment: ppFilter"
      ></span>
    </div>
  }

  @if (matchedListItems?.length === 0 && ppFilter !== '') {
    <div (click)="$event.stopPropagation()">
      <p class="listCF__not-found-message">
        {{ 'no_search_result' | ppTranslate }}
      </p>
    </div>
  }

  @if (ppFilter === '') {
    @for (item of ppItem.subList; track item) {
      @if (item.label) {
        <div
          class="listCF__list-item"
          [class.listCF__list-item--has-sublist]="item.subList?.length > 0"
          >
          <div class="listCF__li-content" [class.listCF__li-content--selected]="isSelected(item.id)">
            <button
              (click)="toggleExpand(item); $event.stopPropagation()"
              class="listCF__arrow-wrapper"
              >
              <pp-icon
              [ppSrc]="
                expanded[item.id]
                  ? EIconPath.ICON_NAV_ARROW_DOWN_14
                  : EIconPath.ICON_NAV_ARROW_RIGHT_14
              "
                ppClass="setSize14"
                ppColor="grey-700"
              ></pp-icon>
            </button>
            <div class="listCF__text" (click)="select(item); $event.stopPropagation()">
              <label>
                {{ item.label }}
              </label>
              <p class="listCF__sublist-count">({{ item.subList?.length }})</p>
            </div>
          </div>
          @if (item.subList?.length > 0 && expanded[item.id]) {
            <div class="listCF__sublist-wrapper">
              <pp-custom-field-list-select
                class="listCF__sublist"
                [ppField]="ppField"
                [ppItem]="item"
                [ppSelectedId]="ppSelectedId"
                [ppLevel]="ppLevel + 1"
                (ppSelect)="selectDeep($event)"
              ></pp-custom-field-list-select>
            </div>
          }
        </div>
      }
    }
  }
</div>
